import type { ColumnFilterOptionItem } from '@/lib/table/types';
import type { TenantUserDtoState } from './user';

/** The backend's sortable whitelist (`TENANT_USER_SORT_FIELDS`); a `sortBy` outside it 400s. */
export const USER_SORT_KEYS = ['lastName', 'firstName', 'email', 'state'] as const;

/**
 * Full vocabularies, not just values in use (see `useUserFilterOptions`);
 * mirrors driver's `DriverColumnFilterOptions`.
 */
export interface UserColumnFilterOptions {
  /**
   * Raw, untranslated — `columns.tsx` labels each via `users:state.<value>`.
   * Kept as the closed `TenantUserDtoState` union so the template-literal
   * `t()` lookup stays key-safe.
   */
  states: TenantUserDtoState[];
  groups: ColumnFilterOptionItem[];
}
